/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Team_Manager_Import_Skipped_CountInputs */



/**
* | output |
* | --- |
* | "{count} will be skipped" |
*
* @param {Team_Manager_Import_Skipped_CountInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_import_skipped_count = /** @type {((inputs: Team_Manager_Import_Skipped_CountInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Import_Skipped_CountInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.count} seront ignorés`)
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} werden übersprungen`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.count} verranno saltati`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Будет пропущено: ${i?.count}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.count} se omitirán`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`${i?.count} 个将被跳过`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`スキップ: ${i?.count}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.count} छोड़ दिए जाएँगे`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`${i?.count} serão ignorados`)
	return /** @type {LocalizedString} */ (`${i?.count} will be skipped`)
});